// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1liJh","col":"styles_col__2LCTx"};